import PostTitle from './post-title'

export default PostTitle



// WEBPACK FOOTER //
// ./src/scenes/feed/post-title/index.js